import { createListenerMiddleware, createSlice, isAnyOf } from '@reduxjs/toolkit';
import { setLocalApiKey, setLocalRecentDocs } from './preferenceApi';
// import { RootState } from '../store';

// interface Preference {
//   apiKey: string;
//   selectedDocs: Doc | null;
//   sourceDocs: Doc[] | null;
//   conversations: { name: string; id: string }[] | null;
// }

const initialState = {
    apiKey: 'xxx',
    selectedDocs: {
        name: 'default',
        language: 'default',
        location: 'default',
        version: 'default',
        description: 'default',
        fullName: 'default',
        dat: 'default',
        docLink: 'default',
        model: 'openai_text-embedding-ada-002'
    },
    sourceDocs: null,
    conversations: null
};

export const prefSlice = createSlice({
    name: 'preference',
    initialState,
    reducers: {
        setApiKey: (state, action) => {
            state.apiKey = action.payload;
        },
        setSelectedDocs: (state, action) => {
            state.selectedDocs = action.payload;
        },
        setSourceDocs: (state, action) => {
            state.sourceDocs = action.payload;
        },
        setConversations: (state, action) => {
            state.conversations = action.payload;
        }
    }
});

export const { setApiKey, setSelectedDocs, setSourceDocs, setConversations } = prefSlice.actions;
export default prefSlice.reducer;

export const prefListenerMiddleware = createListenerMiddleware();
prefListenerMiddleware.startListening({
    matcher: isAnyOf(setApiKey),
    effect: (action, listenerApi) => {
        setLocalApiKey(listenerApi.getState().preference.apiKey);
    }
});

prefListenerMiddleware.startListening({
    matcher: isAnyOf(setSelectedDocs),
    effect: (action, listenerApi) => {
        setLocalRecentDocs(listenerApi.getState().preference.selectedDocs ?? []);
    }
});

export const selectApiKey = (state) => state.preference.apiKey;
export const selectApiKeyStatus = (state) => !!state.preference.apiKey;
export const selectSelectedDocsStatus = (state) => !!state.preference.selectedDocs;
export const selectSourceDocs = (state) => state.preference.sourceDocs;
export const selectSelectedDocs = (state) => state.preference.selectedDocs;
export const selectConversations = (state) => state.preference.conversations;
export const selectConversationId = (state) => state.conversation.conversationId;
